import React from "react";
import classNames from "classnames/bind";
import {ASSET_TYPE, convertDuration} from "utils";
import DefaultThumbnail from "images/objectPanel/ic_default_thumbnail.svg";
import usePlayAssetPreview from "../hooks/usePlayAssetPreview";
import OverlayPlayButton from "../OverlayPlayButton";
import ProgressBar from "../ProgressBar";
import styles from "./index.module.scss";

const cn = classNames.bind(styles);

function ListTypeItemThumbnail({uploadProgress, asset, thumbnail, name, duration, appearance}) {
  const {handlePlay, stopPlay, isPlaying} = usePlayAssetPreview();
  const isSoundPlaying = asset.topCategory === ASSET_TYPE.SOUND && isPlaying;
  const wideImage = asset.midCategory === ASSET_TYPE.CAMERA;

  return (
    <div className={styles.container}>
      <div className={styles.asset_container}>
        <OverlayPlayButton handlePlay={handlePlay} stopPlay={stopPlay} isPlaying={isPlaying} appearance={appearance}>
          <div className={styles.thumbnail_background}>
            <img className={wideImage ? styles.img_wide : styles.img} src={thumbnail || DefaultThumbnail} alt="asset_img" />
          </div>
        </OverlayPlayButton>

        {isSoundPlaying && <audio className={styles.audio} src={asset.url} autoPlay></audio>}

        <div className={cn("info_container", appearance?.singleText, "single_text")}>
          <p className={styles.name}>{name}</p>
          {duration && <p className={styles.duration}>{convertDuration(duration)}</p>}
        </div>
      </div>

      <ProgressBar uploadProgress={uploadProgress} />
    </div>
  );
}

export default ListTypeItemThumbnail;
